import React from 'react';
import { InboxIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function EmptyState() {
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: 'easeOut'
  }} className="flex flex-col items-center justify-center py-20 px-4 text-center" data-id="element-79">
      <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center mb-4 border border-slate-200" data-id="element-80">
        <InboxIcon className="w-6 h-6 text-slate-400" data-id="element-81" />
      </div>
      <h3 className="text-base font-semibold text-slate-800 mb-1" data-id="element-82">
        No deleted Cases found
      </h3>
      <p className="text-sm text-slate-500 max-w-xs leading-relaxed" data-id="element-83">
        There are no deleted Cases associated with this Opportunity in the
        Recycle Bin.
      </p>
    </motion.div>;
}